// import React, { useState } from 'react';
// import { Form, Input, Button, message } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import { auth } from '../api';

// export default function Login() {
//   const [loading, setLoading] = useState(false);
//   const nav = useNavigate();

//   const onFinish = async (vals) => {
//     try {
//       setLoading(true);
//       const res = await auth.login(vals);
//       console.log("hi",res.data.data);
//       localStorage.setItem('token', res.data.data?.token);
//       localStorage.setItem('user', JSON.stringify(res.data.data));
//       nav('/');
//     } catch {
//       message.error('Invalid credentials');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--primary)' }}>
//       <div style={{ width: 360, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: '40px 36px' }}>
//         <div style={{ marginBottom: 32 }}>
//           <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', marginBottom: 8, textTransform: 'uppercase' }}>Shop System</div>
//           <h1 style={{ fontFamily: 'var(--font-mono)', fontSize: 24, color: 'var(--text)', margin: 0 }}>Sign in</h1>
//           <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: '8px 0 0' }}>Inventory & Rental Management</p>
//         </div>
//         <Form layout="vertical" onFinish={onFinish}>
//           <Form.Item name="username" label="Username" rules={[{ required: true }]}>
//             <Input placeholder="admin" size="large" />
//           </Form.Item>
//           <Form.Item name="password" label="Password" rules={[{ required: true }]}>
//             <Input.Password placeholder="••••••••" size="large" />
//           </Form.Item>
//           <Button type="primary" htmlType="submit" loading={loading} size="large" block style={{ marginTop: 8 }}>
//             Sign In
//           </Button>
//         </Form>
//         <div style={{ marginTop: 20, padding: '12px', background: 'var(--surface2)', borderRadius: 6, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-muted)' }}>
//           Default: admin / admin123
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate, Navigate } from 'react-router-dom';
import { auth } from '../api';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const token = localStorage.getItem('token');
  if (token) return <Navigate to="/" replace />;

  const onFinish = async (vals) => {
    try {
      setLoading(true);
      const res = await auth.login(vals);
      console.log("hi",res.data.data);
      localStorage.setItem('token', res.data.data?.token);
      localStorage.setItem('user', JSON.stringify(res.data.data));
      nav('/');
    } catch (err) {
      console.log("qq",err?.response)
       message.error(err?.response?.data?.message || 'Invalid credentials');
      // message.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--primary)' }}>
      <div style={{ width: 360, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: '40px 36px' }}>
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.2em', marginBottom: 8, textTransform: 'uppercase' }}>Shop System</div>
          <h1 style={{ fontFamily: 'var(--font-mono)', fontSize: 24, color: 'var(--text)', margin: 0 }}>Sign in</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: '8px 0 0' }}>Inventory & Rental Management</p>
        </div>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label="Username" rules={[{ required: true }]}>
            <Input placeholder="admin" size="large" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password placeholder="••••••••" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} size="large" block style={{ marginTop: 8 }}>
            Sign In
          </Button>
        </Form>
        <div style={{ marginTop: 20, padding: '12px', background: 'var(--surface2)', borderRadius: 6, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-muted)' }}>
          Default: admin / admin123
        </div>
      </div>
    </div>
  );
}
